import React, { ChangeEvent } from "react";

import ModalDialog, { IModalDialogBaseProps } from "./ModalDialog";

import { V2 } from "../../Api";

import "../../form.css";

interface IVehicleAddPaymentDialogProps extends IModalDialogBaseProps {
    vehicle: any;
    paymentType?: "tag" | "insurance" | "kbb" | "purchaseprice"
}

interface IVehicleAddPaymentDialogState {
    submitStatus: boolean | string;

    date: string;
    cost: string;

    nextDate: string;
}

class VehicleAddPaymentDialog extends React.Component<IVehicleAddPaymentDialogProps, IVehicleAddPaymentDialogState> {
    constructor(props: Readonly<IVehicleAddPaymentDialogProps>) {
        super(props);

        this.state = {
            submitStatus: false,
            date: "",
            cost: "",

            nextDate: "",
        };

        this.submit = this.submit.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
    }

    public componentDidUpdate(prevProps: Readonly<IVehicleAddPaymentDialogProps>) {
        if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
            // Clear fields
            this.setState({
                date: "",
                cost: "",

                nextDate: "",
            });
        }
    }

    public render() {
        const info = this.typeToText();
        const { isOpen, onRequestClose } = this.props;
        return <ModalDialog isOpen={isOpen} onRequestClose={onRequestClose} className="modal-500px" title={info.title}>
            <div className="input-form">
                <div className="info-block">
                    <section>
                        <div className="input-form-group">
                            <div>{info.addText} for <b>{this.props.vehicle.name} {this.props.vehicle?.color || ""} ({this.props.vehicle?.tag || "No tag"})</b></div>
                        </div>
                    </section>
                    <section>
                        <div className="input-form-group">
                            <label htmlFor="frm-date" className="required">Date</label>
                            <input type="date" id="frm-date" name="date" value={this.state.date} onChange={this.handleInputChanged} />
                        </div>
                        <div className="input-form-group">
                            <label htmlFor="frm-cost" className="required">{info.costText}</label>
                            <input type="number" id="frm-cost" name="cost" step={0.01} min={0.00} value={this.state.cost} onChange={this.handleInputChanged} />
                        </div>
                    </section>
                    {info.showRenewalDate
                        ? <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-date-next">Next renewal date</label>
                                <input type="date" id="frm-date-next" name="nextDate" value={this.state.nextDate} onChange={this.handleInputChanged} />
                            </div>
                        </section>
                        : null
                    }
                    &nbsp;
                    {this.state.submitStatus === true
                        ? <div className="spinner lds-dual-ring" />
                        : typeof this.state.submitStatus === "string"
                            ? <div className="error-text">{this.state.submitStatus}</div>
                            : null
                    }
                    <div className="action-panel-dialog">
                        <button type="button" className="button push-right text-with-icon" onClick={this.submit}><i className="icon-check" /><span>Save</span></button>
                    </div>
                </div>
            </div>
        </ModalDialog>;
    }

    private async submit() {
        try {
            this.setState({
                submitStatus: true
            });

            if (!this.state.date) {
                throw new Error("Date must not be empty");
            }
            if (!this.state.cost) {
                throw new Error("Cost must not be empty");
            }

            let data;
            switch (this.props.paymentType) {
                case "tag":
                    data = {
                        tagtax: {
                            renewalDate: this.state.date,
                            cost: this.state.cost,
                            nextTagRenewalDate: this.state.nextDate || undefined
                        }
                    };
                    break;
                case "insurance":
                    data = {
                        insurance: {
                            date: this.state.date,
                            cost: this.state.cost,
                        }
                    };
                    break;
                case "kbb":
                    data = {
                        kbb: {
                            date: this.state.date,
                            value: this.state.cost
                        }
                    };
                    break;
                case "purchaseprice":
                    data = {
                        purchase: {
                            date: this.state.date,
                            price: this.state.cost
                        }
                    };
                    break;
                default:
                    throw new Error("Unknown type " + this.props.paymentType);
            }

            await V2.post(`vehicles/${this.props.vehicle.id}/costvalue`, data);

            this.setState({
                submitStatus: false
            });

            this.props.onRequestClose(true);
        }
        catch (e) {
            this.setState({
                submitStatus: e.message || "Failed to submit"
            });
        }
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLTextAreaElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState({
            [name]: value
        } as any);
    }

    private typeToText() {
        switch (this.props.paymentType) {
            case "tag": return {
                title: "Tag renewal",
                addText: "Add tag renewal",
                showRenewalDate: true,
                costText: "Cost",
            };
            case "insurance": return {
                title: "Insurance payment",
                addText: "Add insurance payment",
                showRenewalDate: false,
                costText: "Cost",
            };
            case "kbb": return {
                title: "Update KBB Value",
                addText: "Enter the latest Kelly Blue Book value",
                showRenewalDate: false,
                costText: "Value",
            };
            case "purchaseprice": return {
                title: "Set original purchase price",
                addText: "Enter the original purchase price & date",
                showRenewalDate: false,
                costText: "Price",
            };
            default: throw new Error("Unknown dialog type");
        }
    }
}

export default VehicleAddPaymentDialog;
